__turbopack_context__.v({
  "borderWrapper": "styles-module-scss-module__q96uSa__borderWrapper",
  "fancyBtn": "styles-module-scss-module__q96uSa__fancyBtn",
});
